<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Todos los cultivos</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>

        <div>
          <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Nombre" min-width="180px" prop="name" sortable> </el-table-column>

        <el-table-column label="Unidad" min-width="180px" prop="unit" sortable> </el-table-column>

        <el-table-column label="Es para venta" min-width="100px" prop="forSale" sortable>
          <template #default="{ row }">
            <div>
              {{ row.forSale ? 'Si' : 'No' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="140px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('update', 'crops')"
              :to="{ name: 'CropEdit', params: { id: row.id } }"
              class="btn base-button btn-outline-primary btn-sm"
            >
              <i class="fas fa-pen"></i>
            </router-link>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ total }} cultivos</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        class="pagination-no-border"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';

export default {
  name: 'CropsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationMixin],
  data() {
    return {
      searchKeys: ['name'],
      tableData: [],
      tableName: 'CropsTable',
    };
  },

  mounted() {
    this.$services
      .resource('crops')
      .get()
      .then((res) => res.data.data)
      .then((data) => (this.tableData = data.crops));
  },
};
</script>
